import React, { Component, useEffect } from 'react'
import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import isEmpty from 'lodash/isEmpty'
import { createAction } from 'redux-actions'
import { bindActionCreators } from 'redux'
import { Section } from './Form'
import { connect } from 'react-redux'
import styles from './Form.scss'
import { withTranslation } from 'react-i18next'

const flattenErrors = function*(errors, route = []) {
  if (isArray(errors)) {
    for (let index = 0; index < errors.length; index++) {
      yield* flattenErrors(errors[index], [{ index, errors }, ...route])
    }
  } else {
    for (let key in errors) {
      const value = errors[key]
      if (isObject(value)) {
        // object or array
        yield* flattenErrors(value, [{ key, errors }, ...route])
      } else {
        yield { value, route: [{ key, errors }, ...route] }
      }
    }
  }
}

const getErrorMessages = function*(errors, fields) {
  for (let error of errors) {
    const { value, route } = error
    const name = route
      .map(({ index, key, errors }) => (isArray(errors) ? `[${index}]` : `.${key}`))
      .reverse()
      .join('')
    const message =
      route
        .map(({ index, key, errors }) => (isArray(errors) ? `【${index}】` : fields[key] || key))
        .reverse()
        .join('') + value
    yield { name, message }
  }
}

export const onSubmitFail = (errors, dispatch) => {
  const errorList = [...flattenErrors(errors)]
  dispatch(setErrors(errorList))
}

class FormErrors extends Component {
  componentWillUnmount() {
    this.props.reset()
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors && !isEmpty(this.props.errors)) {
      this._main.scrollIntoView()
    }
  }

  render() {
    const { errors, fields } = this.props
    const messages = [...getErrorMessages(errors, fields)]
    return (
      <div ref={div => (this._main = div)}>
        {!isEmpty(messages) && (
          <Section title={this.props.t("jbc-front.components.FormErrors.Input_information_is_incorrect")} error>
            <ul className={styles.errorHead}>{messages.map(({ name, message }) => <li key={name}>{message}</li>)}</ul>
          </Section>
        )}
      </div>
    )
  }
}

const LabelMapperComonent = ({ addField, name, label }) => {
  useEffect(
    () => {
      addField({ [name]: label })
    },
    [name, label]
  )
  return null
}

const SET_ERRORS = 'FORM_ERRORS/SET_ERRORS'
const ADD_FIELD = 'FORM_ERRORS/ADD_FIELD'
const RESET = 'FORM_ERRORS/RESET'

const setErrors = createAction(SET_ERRORS)
const addField = createAction(ADD_FIELD)
const reset = createAction(RESET)

const initialState = {
  errors: [],
  fields: {}
}

export const LabelMapper = connect(null, bindActionCreators.bind(null, { addField }))(LabelMapperComonent)

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERRORS:
      return { ...state, errors: action.payload }
    case ADD_FIELD:
      return { ...state, fields: { ...state.fields, ...action.payload } }
    case RESET:
      return { ...state, errors: initialState.errors }
    default:
      return state
  }
}

export default withTranslation()(connect(state => state.formErrors, bindActionCreators.bind(null, { reset }))(FormErrors))
